import graphql from './graphql';

const query = /* GraphQL */ `
  query getListedObjects($key: String) {
    getListedObjects(key: $key) {
      prefix
      total
      files {
        key
        size
        fileName
      }
    }
  }
`;

const S3ListedObjects = async key => graphql(query, { key }).then(({ getListedObjects }) => getListedObjects);

export default S3ListedObjects;
